import axios from 'axios';

export async function getCachedResults(location) {
  if (!location) return null;
  
  try {
  console.log("location..........")
  console.log(location)
    const [city, country] = location.split(',').map(item => item.trim());
    const cacheKey = `${country.toLowerCase()}_${city.toLowerCase()}`;
    const sanitizedCacheKey = encodeURIComponent(cacheKey);
    console.log('Fetching cache for:', sanitizedCacheKey); // Debug log

    const response = await axios.get(
      `https://api.farmersmarketnear.me/api/cache/${sanitizedCacheKey}`,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('Cache response:', response.data); // Debug log
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      console.log('Cache miss for:', location); // Debug log
      return null;
    }
    console.error('Cache error:', error.response?.data || error.message); // Debug log
    return null;
  }
}

export async function setCachedResults(location, data) {
  if (!location || !data) return;

  try {
    const [city, country] = location.split(',').map(item => item.trim());
    const cacheKey = `${country.toLowerCase()}_${city.toLowerCase()}`;
    const sanitizedCacheKey = encodeURIComponent(cacheKey);
    console.log('Setting cache for:', sanitizedCacheKey); // Debug log

    const response = await axios.post(
      `https://api.farmersmarketnear.me/api/cache/${sanitizedCacheKey}`,
      {
        data,
        expiresAt: new Date(Date.now() + 180 * 24 * 60 * 60 * 1000).toISOString() // 180 days
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('Cache set response:', response.data); // Debug log
    return response.data;
  } catch (error) {
    console.error('Error setting cache:', error.response?.data || error.message);
    throw error;
  }
}
